import { useParams } from 'react-router-dom';
import Layout from '../../components/Layout/Layout';
import { useEffect, useState } from 'react';
import { getEncargoById } from '../../services/encargos';
import { Box, Heading } from '@chakra-ui/react';
import GridInfoEncargo from '../../components/Encargos/CRUD/GridInfoEncargo';
import GridInfoInmuebles from '../../components/Inmuebles/CRUD/GridInfoInmuebles';
import TablaActividadesEncargo from '../../components/Actividades/TablaActividadesEncargo';
import Separador from '../../components/Separador/Separador';
import ListaDocumentosEncargo from '../../components/Documentos/ListaDocumentosEncargo';

const VerEncargo = () => {
	const { id } = useParams();
	const [encargo, setEncargo] = useState();
	const [needReload, setNeedReload] = useState(true);

	useEffect(() => {
		const fetchEncargo = async () => {
			setNeedReload(false);
			const response = await getEncargoById(id);
			setEncargo(response);
		};
		needReload && fetchEncargo();
	}, [id, needReload]);

	return (
		<Layout>
			<Box mb={{ base: 4, md: 6 }}>
				<Heading textAlign='center'>Encargo</Heading>
			</Box>

			<Box maxW='7xl' mx='auto'>
				{encargo && (
					<>
						<GridInfoEncargo encargo={encargo} />
						<Separador />
						<Heading textAlign='center' mb={2}>
							Inmueble
						</Heading>
						<GridInfoInmuebles
							formData={encargo.inmueble}
							hideActividades={true}
						/>
						<Box mb={{ base: 4, md: 6 }}>
							<TablaActividadesEncargo datos={encargo} />
							<Separador />
							<ListaDocumentosEncargo
								encargoUuid={encargo.uuid}
							/>
						</Box>
					</>
				)}
			</Box>
		</Layout>
	);
};

export default VerEncargo;
